import { API } from "../api";

const BASE_URL = "/cooperatives/reports/sms-history";

export const smsHistoryExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getBranchSmsHistory: builder.query({
      query: ({
        page = 1,
        limit = 20,
        date_from,
        date_to,
        source_type,
        status,
        recipient_phone,
      }) => {
        const params = new URLSearchParams({
          guard: "staff",
          page: page.toString(),
          limit: limit.toString(),
        });

        if (date_from) params.append("date_from", date_from);
        if (date_to) params.append("date_to", date_to);
        if (source_type) params.append("source_type", source_type);
        if (status) params.append("status", status);
        if (recipient_phone) params.append("recipient_phone", recipient_phone);

        return {
          url: `${BASE_URL}?${params.toString()}`,
        };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "SmsHistory", id: "branch-list" },
      ],
      cacheStrategy: "cache-and-network",
    }),

    getCompanySmsHistory: builder.query({
      query: ({
        page = 1,
        limit = 20,
        date_from,
        date_to,
        source_type,
        status,
        recipient_phone,
      }) => {
        const params = new URLSearchParams({
          guard: "staff",
          page: page.toString(),
          limit: limit.toString(),
        });

        if (date_from) params.append("date_from", date_from);
        if (date_to) params.append("date_to", date_to);
        if (source_type) params.append("source_type", source_type);
        if (status) params.append("status", status);
        if (recipient_phone) params.append("recipient_phone", recipient_phone);

        return {
          url: `${BASE_URL}/company?${params.toString()}`,
        };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "SmsHistory", id: "company-list" },
      ],
      cacheStrategy: "cache-and-network",
    }),

    getSmsStatistics: builder.query({
      query: ({ date_from, date_to, branch_id }) => {
        const params = new URLSearchParams({
          guard: "staff",
        });

        if (date_from) params.append("date_from", date_from);
        if (date_to) params.append("date_to", date_to);
        if (branch_id) params.append("branch_id", branch_id);

        return {
          url: `${BASE_URL}/statistics?${params.toString()}`,
        };
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "SmsHistory", id: "statistics" },
      ],
      cacheStrategy: "cache-and-network",
    }),

    getSmsLogById: builder.query({
      query: (logId) => ({
        url: `${BASE_URL}/${logId}?guard=staff`,
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (result, error, arg) => [
        { type: "SmsHistory", id: arg },
      ],
      cacheStrategy: "cache-and-network",
    }),
  }),
});

export const {
  useGetBranchSmsHistoryQuery,
  useGetCompanySmsHistoryQuery,
  useGetSmsStatisticsQuery,
  useGetSmsLogByIdQuery,
} = smsHistoryExtendedApi;
